<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>专家</span><span style="color:#D7230C;">智库</span></div>
							<div class="sm_pub">有困难找我们</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">专家智库</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div class="top_bottom_T">
					<div class="dtiail_warp">
						<div style="width: 95%;margin-left: 2%;margin-top: 20px;height: 300px;">
							<div style="width: 25%;height: 250px;margin-top: 25px;float: left;">
								<img v-lazy="contents.picture" style="width: 100%;height: 100%;" alt="">
							</div>
							<div style="width: 70%;height: 250px;margin-top: 25px;float: left;margin-left: 3%;">
								<div style="height: 90px;line-height: 90px;width: 100%;border-bottom: 1px dashed #D7230C;font-size: 30px;font-weight: 800;">
									{{contents.title}} 
									<img src="./i-role.png" style="margin-left: 20px;margin-top: 10px;" alt="">
								</div>
								<div style="height: 20px;margin-top: 15px;line-height: 20px;">
									{{contents.company}}
								</div>
								<div style="height: 20px;margin-top: 15px;line-height: 20px;">
									{{contents.position}}
								</div>
								<div style="height: 20px;margin-top: 15px;line-height: 20px;">
									状态:{{contents.onjob}}
								</div>
								<div v-if="contents.phone!='' ">
									
									<div v-if="!ckck" style="height: 20px;margin-top: 15px;line-height: 15px;" @click="zfnmb">
										<!-- {{o.position}} &nbsp; *{{o.title.slice(-1)}} -->
										<!-- ****{{`${o.phone}`.substring(4,7)}}**** -->
										 <img src="./tell.png" style="width:20px;height:20px;" /><span>&nbsp;&nbsp;</span> ***{{contents.onjob.substring(2,3)}}**** <span>&nbsp;&nbsp;</span>  <img src="./weixin.png" style="width:25px;height:25px;" /><span>&nbsp;&nbsp;</span>***{{contents.wechat.substring(2,3)}}***<span>&nbsp;&nbsp;</span> <img src="./youxiang.png" style="width:25px;height:25px;" /><span>&nbsp;&nbsp;</span>***{{contents.onjob.substring(2,3)}}***
									</div>
									<div v-if="ckck" style="height: 20px;margin-top: 15px;line-height: 15px;" @click="zfnmb">
										 <img src="./tell.png" style="width:20px;height:20px;" /><span>&nbsp;&nbsp;</span> {{contents.phone}} <span>&nbsp;&nbsp;</span> <img src="./weixin.png" style="width:25px;height:25px;" /><span>&nbsp;&nbsp;</span>{{contents.wechat}}<span>&nbsp;&nbsp;</span><img src="./youxiang.png" style="width:25px;height:25px;" /><span>&nbsp;&nbsp;</span>{{contents.mail}}
									</div>
									
								</div>
								
							</div>
						</div>
						<div style="width: 95%;margin-left: 2%;margin-top: 20px;height: 30px;">
							<div style="width: 20px;height: 30px;background-color: red;float: left;">
								
							</div>
							<div style="width: 100px;height: 30px;text-align: center;line-height: 30px;font-size: 20px;font-weight: 800;margin-left: 20px;float: left;">
								专家介绍
							</div>
							<div style="width: 83%;height: 15px;float: left;border-bottom: 1px solid #6e6e6e;">
								
							</div>
						</div>
						<div style="width: 95%;margin-left: 2%;margin-top: 20px;" v-html="contents.describtion">
							
						</div>
						
					</div>
					<div style="width: 95%;margin: 20px auto;height: 100px;border-top: 1px dashed #ddd;">
						<div @click="sca"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 35%;">
							<img class="scname" src="../../../imges/dsdsdsds/shoucang1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								收藏
							</div>
						</div>
						<div  @click="getShareInfo"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
							<img class="scname" src="../../../imges/dsdsdsds/weixin1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								微信
							</div>
						</div>
						<div @click="fxkj"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
							<img class="scname" src="../../../imges/dsdsdsds/qqkongjian1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								空间
							</div>
						</div>
						<div @click="das"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;border-radius: 50%;">
							<img class="scname" src="../../../imges/dsdsdsds/dashang1.png"
								style="width: 100%;height: 50px;" alt="">
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
									打赏
								</div>
						</div>
					</div>
				</div>
				<!-- 侧边栏 -->
				<div class="top_bottom_B">
					<rightlist></rightlist>
				</div>
			</div>
			

		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
		<qbessd ref="dashang"></qbessd>
		<dashang ref="child" :dsje="dsje"></dashang>
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;" @click="fha">
				  返回
		</div>
		<!-- 微信分享 -->
		<div class="popContainer" v-show="isShowQR" @click="gbgb">
			<vue-qr style="display: inline-block;
		position: absolute;
		top: 40%;
		left: 40%;" :logoSrc="imageUrl" :text="Text" :size="200"></vue-qr>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import vueQr from 'vue-qr'
	export default {
		data() {
			return {
				ckck:false,
				options: [],
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				imageUrl: 'https://img1.baidu.com/it/u=3311948344,2093308219&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500',
				Text: '',
				isShowQR: false, //二维码显示
				letData: true,
				value: '',
				id: this.$route.query.id,
				title: this.$route.query.title,
				mid: this.$route.query.mid,
				contents: '',
				dsje: [{
					tid: this.$route.query.id,
					nologin_type: 'zjzk',
					name: '专家智库打赏',
					price: 0,
				}],
			}
		},
		methods: {
			fha(){
				this.$router.go(-1);//返回上一层
			},
			gbgb() {
				this.isShowQR = false
				// $('#qrCodeUrl').html = ''
			},
			async das(id, sb) {
				let that = this
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				this.$refs.dashang.DS_ck(50, '专家智库', 'zjzkds', loginInfo.id)
				// this.$refs.dashang.DS_ck(price, '下载', 'qkyd', tid)
			// 	this.sid = loginInfo.id
			// 	if (loginInfo) {
			// 		let res = await http.post('api/picture/login_yz', {
			// 			tid: id,
			// 			nologin_type: 'txl',
			// 			uid: loginInfo.id
			// 		})
			
			// 		console.log(res)
			// 		if (res.data.code == 500) {
			// 			this.$refs.dashang.DS_ck(20, '通讯录查看', 'txl', id)
			// 			// that.$refs.child.isShowZF = true //修改子组件data
			// 		} else {
			// 			this.$router.push({
			// 				path:`/txldetail?id=${id}&title=${sb},`
			// 			})
			// 		}
			// 	} else {
			// 		this.$message.error('请先登录');
			// 		this.$router.replace('/login')
			// 	}
			},
			async zfnmb(){
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if(loginInfo){
					let res = await http.post('api/picture/login_yz',{
						nologin_type:'zjzkds',
						tid:this.$route.query.id,
						uid:loginInfo.id
					})
					console.log(res)
					if(res.data.code == '500'){
						console.log('支付')
						this.$refs.dashang.DS_ck(50, '专家智库电话查看', 'zjzkds', this.$route.query.id)
					} else {
						console.log('未支付')
						this.ckck = true
					}
				}else {
					this.$router.replace('/login')
				}
				
			},
			das() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					this.$refs.child.isShowZF = true //修改子组件data
				} else {
					this.$router.replace('/login')
				}
			},
			fxkj() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					const share = {
						title: this.contents.title,
						desc: "海工人|船海智造360°综合服务平台",
						image_url: [this.contents.picture],
						share_url: "https://www.shipoe360.com/#" + this.$route.path + '?id=' + this.id  
					};
					//跳转地址
					location.replace(
						"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
						encodeURIComponent(share.share_url) +
						"&title=" +
						share.title +
						"&pics=" +
						share.image_url.join("|") +
						"&summary=" +
						share.desc
					);
				} else {
					this.$router.replace('/login')
				}
			},
			getShareInfo() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					if (this.letData) {
						let myhref = window.location.href
						console.log(myhref)
						this.Text = myhref
						this.isShowQR = true
						this.letData = false
					} else {
						this.isShowQR = true
					}
				} else {
					this.$router.replace('/login')
				}
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleDateString().replace(/:\d{1,2}$/, ' ');
			},
			async sca() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					let res = await http.post('api/picture/personal_collection', {
						uid: loginInfo.id,
						title: this.contents.title,
						picture: this.contents.picture,
						pc_link: this.$route.path + '?id=' + this.id + '&title=' + this.title,
						url_link: 'pages/informations/index?id='  + this.id + '?zy=zy',
					})
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '收藏成功',
							type: 'success'
						});
					} else {
						this.$notify({
							title: '失败',
							message: res.data.msg,
							type: 'error'
						});
					}
				} else {
					this.$router.replace('/login')
				}
			},
		},
		async mounted() {
			let res = await http.get('index.php/bscard/wxapp.Sorts')
			this.options = res.data.data

			let res1 = await http.post('api/industry/expertContent', {
				id: this.id,
			})
			console.log(res1)
			this.contents = res1.data.data.data
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//测标签
			rightlist: resolve => require(['@/components/dpubtop/rightList.vue'], resolve),
			//广澳
			PCguangao: resolve => require(['@/components/dpubtop/PCguangao.vue'], resolve),
			//相关阅读
			Xguanyuedu: resolve => require(['@/components/dpubtop/xgyd.vue'], resolve),
			dashang: resolve => require(['@/components/dashang/dashang.vue'], resolve),
			qbessd: resolve => require(['@/components/dashang/dashangs.vue'], resolve),
			vueQr,
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}


	/* 头部结束 */
	.top_bottom {
		width: 100%;
		clear:both;
		overflow:hidden;
		height: 100%;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_bottom_T {
		width: 75%;
		float: left;
	}

	.top_bottom_B {
		width: 25%;
		float: left;
	}

	.dtiail_warp {
		width: 95%;
		margin: 0 auto;
	}

	.dtiail_title {
		margin-top: 40px;
		margin-bottom: 16px;
		text-align: center;
		font-size: 22px;
		color: #c00e0e;
	}

	.cont_dtiail>>>p>>>img {
		width: auto;
		height: 100%;
	}

	.cont_dtiail {
		overflow: hidden;
		margin-top: 20px;
		min-height: 300px;
	}
	
	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(0, 0, 0, 0.6);
	}
</style>
